// Global fetch interceptor - automatically adds Bearer token to API requests
// This replaces credentials:'include' (cookie-based) with token-based auth

const API_URL = process.env.REACT_APP_BACKEND_URL;

const originalFetch = window.fetch;

window.fetch = function (url, options = {}) {
  // Only intercept API calls to our backend
  if (typeof url === 'string' && API_URL && url.startsWith(API_URL)) {
    const token = localStorage.getItem('inktrack_token');
    if (token) {
      options.headers = {
        ...(options.headers || {}),
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      };
    } else {
      options.headers = {
        ...(options.headers || {}),
        'Accept': 'application/json',
      };
    }
    // Remove credentials:'include' - not needed with token auth
    delete options.credentials;
  }

  return originalFetch.call(this, url, options);
};
